export default __webpack_public_path__ + "static/media/QRCode.b0a5f2e6.png";